import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets scroll position to the top on every route change. Without this,
// navigating to a new page (e.g. clicking "Calculate" on a product list
// scrolled halfway down) keeps the browser's previous scroll offset, making
// the new page appear scrolled into the middle of its content.
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
